var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepoTwo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8182 11.6788V16.5466C14.8182 17.5005 14.0449 18.2738 13.091 18.2738H2.72728C1.77333 18.2738 1 17.5005 1 16.5466V9.63744C1 8.68349 1.77333 7.91016 2.72728 7.91016H4.45456",
    stroke: "white",
    strokeWidth: 1.29546,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2726 16.5471C19.7035 16.5471 20.8635 15.3871 20.8635 13.9562C20.8635 12.5252 19.7035 11.3652 18.2726 11.3652C16.8416 11.3652 15.6816 12.5252 15.6816 13.9562C15.6816 15.3871 16.8416 16.5471 18.2726 16.5471Z",
    stroke: "white",
    strokeWidth: 1.72728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90879 10.5002C9.33972 10.5002 10.4997 9.34021 10.4997 7.90928C10.4997 6.47835 9.33972 5.31836 7.90879 5.31836C6.47787 5.31836 5.31787 6.47835 5.31787 7.90928C5.31787 9.34021 6.47787 10.5002 7.90879 10.5002Z",
    stroke: "white",
    strokeWidth: 1.72728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1455 9.21289L16.0442 12.6502",
    stroke: "white",
    strokeWidth: 1.72728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7555 4.3508C16.6808 4.3508 17.4309 3.6007 17.4309 2.6754C17.4309 1.7501 16.6808 1 15.7555 1C14.8302 1 14.0801 1.7501 14.0801 2.6754C14.0801 3.6007 14.8302 4.3508 15.7555 4.3508Z",
    stroke: "white",
    strokeWidth: 1.11693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3087 3.51953L10.5 5.74223",
    stroke: "white",
    strokeWidth: 1.11693,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepoTwo);
export default __webpack_public_path__ + "static/media/repoTwo.c61d3cb27234eafd1729ff3b37c780ec.svg";
export { ForwardRef as ReactComponent };